import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'portal.components.errorBoundary.title',
    defaultMessage: 'Something went wrong',
    description: 'Heading shown by the app-wide error boundary fallback panel when a render error is caught',
  },
  message: {
    id: 'portal.components.errorBoundary.message',
    defaultMessage: "We're sorry, something unexpected happened. You can try again or go back to the homepage.",
    description: 'Body copy shown by the app-wide error boundary fallback panel when a render error is caught',
  },
  retry: {
    id: 'portal.components.errorBoundary.retry',
    defaultMessage: 'Try again',
    description: 'Button label to retry rendering after the error boundary catches a render error',
  },
  backHome: {
    id: 'portal.components.errorBoundary.backHome',
    defaultMessage: 'Back to homepage',
    description: 'Link label to navigate back to the homepage after the error boundary catches a render error',
  },
});

export default messages;
